function applyCollectionViewToAll() {
  const isDesktop = window.matchMedia('(min-width: 1024px)').matches;

  const productGridContainer = document.getElementById('ProductGridContainer');
  if (!productGridContainer) return;

  const cardGrid = productGridContainer.querySelector('.card-grid');
  if (!cardGrid) return;

  const motionList = cardGrid.closest('motion-list');
  const initialView = motionList?.getAttribute('data-view') || 'list';
  const storedView = localStorage.getItem('collectionView');
  const validStored = storedView === 'grid' || storedView === 'list' ? storedView : null;
  const preferredView = isDesktop ? (validStored || initialView || 'list') : 'grid';

  const gridItems = cardGrid.querySelectorAll('.grid-view-item');
  const listItems = cardGrid.querySelectorAll('.list-view-item');

  if (preferredView === 'list' && isDesktop) {
    cardGrid.classList.remove('grid');
    cardGrid.setAttribute('data-view', 'list');

    gridItems.forEach((item) => {
      item.style.display = 'none';
    });

    listItems.forEach((item) => {
      item.style.display = 'block';
      item.style.width = '100%';
    });
  } else {
    cardGrid.classList.add('grid');
    cardGrid.setAttribute('data-view', 'grid');

    gridItems.forEach((item) => {
      item.style.display = '';
    });

    listItems.forEach((item) => {
      item.style.display = 'none';
    });
  }
}

if (!customElements.get('facet-form')) {
  customElements.define(
    'facet-form',
    class FacetForm extends HTMLFormElement {
      constructor() {
        super();

        this.dirty = false;
        this.cachedMap = new Map();
        this.isMobile = theme.config.mqlSmall || theme.config.isTouch;
        this.motionReduced = theme.config.motionReduced || this.hasAttribute('motion-reduced');

        this.addEventListener('change', this.onFormChange);
        this.addEventListener('submit', this.onFormSubmit);
      }

      getAnimationParams() {
        return {
          distance: this.isMobile ? 30 : 50,
          duration: this.motionReduced ? 0.001 : (this.isMobile ? 0.3 : 0.5),
          staggerDelay: this.motionReduced ? 0 : (this.isMobile ? 0.05 : 0.1)
        };
      }

      getVisibleItems(items) {
        const viewportHeight = window.innerHeight + window.scrollY;
        const visible = [];
        const invisible = [];
        
        items.forEach(item => {
          const rect = item.getBoundingClientRect();
          const isVisible = rect.top < viewportHeight && rect.bottom > 0;
          
          if (isVisible) {
            visible.push(item);
          } else {
            invisible.push(item);
          }
        });
        
        return { visible, invisible };
      }

      onFormChange() {
        this.dirty = true;
        this.dispatchEvent(new Event('submit', { cancelable: true }));
      }

      onFormSubmit(event) {
        event.preventDefault();
        if (!this.dirty) return;

        const url = this.buildUrl().toString();
        this.renderSection(url, event);
      }

      buildUrl() {
        const searchParams = new URLSearchParams(new FormData(this));
        const url = new URL(this.action);

        url.search = '';
        searchParams.forEach((value, key) => url.searchParams.append(key, value));

        ['page', 'filter.v.price.gte', 'filter.v.price.lte'].forEach((item) => {
          if (url.searchParams.get(item) === '') {
            url.searchParams.delete(item);
          }
        });

        url.searchParams.set('section_id', theme.utils.sectionId(this));
        return url;
      }

      updateURLHash(url) {
        const clonedUrl = new URL(url);
        clonedUrl.searchParams.delete('section_id');
        history.replaceState({}, '', clonedUrl.toString());
      }

      beforeRenderSection() {
        const container = document.getElementById('ProductGridContainer');
        const items = container.querySelectorAll('.product-card');

        const { distance, duration, staggerDelay } = this.getAnimationParams();
        const { visible: visibleItems, invisible: inVisibleItems } = this.getVisibleItems(items);

        Motion.timeline([
          [visibleItems, { y: distance, opacity: 0, visibility: 'hidden' }, { duration: duration, delay: Motion.stagger(staggerDelay) }],
          [inVisibleItems, { y: distance, opacity: 0, visibility: 'hidden' }, { duration: duration }],
          [container, { y: distance, opacity: 0 }, { duration: duration, easing: 'linear' }]
        ]);
        items.forEach(item => item.style.removeProperty('transform'));

        let headerHeight = 0;
        if (!theme.config.mqlSmall && document.querySelector('header.header')) {
          headerHeight = Math.round(document.querySelector('header.header').clientHeight);
        }
        setTimeout(() => {
          const target = document.querySelector('.collection');
          window.scrollTo({
            top: target.getBoundingClientRect().top + window.scrollY - (theme.config.isTouch || theme.config.mqlSmall ? 95 : 20) - headerHeight,
            behavior: theme.config.motionReduced ? 'auto' : 'smooth'
          });

          const drawer = document.getElementById('FacetDrawer');
          if (drawer) drawer.classList.add('loading');
        }, 100);
      }

      afterRenderSection() {
        const container = document.getElementById('ProductGridContainer');
        const items = container.querySelectorAll('.product-card');

        const { distance, duration, staggerDelay } = this.getAnimationParams();
        const { visible: visibleItems, invisible: inVisibleItems } = this.getVisibleItems(items);

        Motion.timeline([
          [container, { y: [distance, 0], opacity: [0, 1] }, { duration: duration, easing: 'linear' }],
          [visibleItems, { y: [distance, 0], opacity: [0, 1], visibility: ['hidden', 'visible'] }, { duration: duration, delay: Motion.stagger(staggerDelay) }],
          [inVisibleItems, { y: [distance, 0], opacity: [0, 1], visibility: ['hidden', 'visible'] }, { duration: duration }]
        ]);
        items.forEach(item => item.style.removeProperty('transform'));

        const drawer = document.getElementById('FacetDrawer');
        if (drawer) drawer.classList.remove('loading');

        document.dispatchEvent(new CustomEvent('collection:reloaded'));
      }

      renderSection(url, event) {
        this.cachedMap.has(url)
          ? this.renderSectionFromCache(url, event)
          : this.renderSectionFromFetch(url, event);

        if (this.hasAttribute('data-history')) this.updateURLHash(url);

        this.dirty = false;
      }

      renderSectionFromFetch(url, event) {
        this.abortController?.abort();
        this.abortController = new AbortController();
        
        this.beforeRenderSection();
        const start = performance.now();

        fetch(url, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            const execution = (performance.now() - start);

            setTimeout(() => {
              this.renderFilters(responseText, event);
              this.renderFiltersActive(responseText);
              this.renderProductGridContainer(responseText);
              this.renderProductCount(responseText);
              this.renderSortBy(responseText);

              theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.facetUpdate, { responseText: responseText });
              this.cachedMap.set(url, responseText);

              this.afterRenderSection();
            }, execution > 500 ? 0 : 500);
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            }
            else {
              console.error(error);
            }
          });
      }

      renderSectionFromCache(url, event) {
        this.beforeRenderSection();

        setTimeout(() => {
          const responseText = this.cachedMap.get(url);
          this.renderFilters(responseText, event);
          this.renderFiltersActive(responseText);
          this.renderProductGridContainer(responseText);
          this.renderProductCount(responseText);
          this.renderSortBy(responseText);

          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.facetUpdate, { responseText: responseText });

          this.afterRenderSection();
        }, 500);
      }

      renderFilters(responseText, event) {
        const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
        const facetElements = parsedHTML.querySelectorAll(
          '#FacetFiltersContainer [data-filter], #MobileFacetFiltersContainer [data-filter]'
        );

        const matchesIndex = (element) => {
          const jsFilter = event ? event.target.closest('[data-filter]') : undefined;
          return jsFilter ? element.getAttribute('data-index') === jsFilter.getAttribute('data-index') : false;
        };
        const facetsToRender = Array.from(facetElements).filter((element) => !matchesIndex(element));

        facetsToRender.forEach((element) => {
          const filter = document.querySelector(`[data-filter][data-index="${element.getAttribute('data-index')}"]`);
          if (filter !== null) {
            if (filter.tagName === 'DETAILS') {
              filter.querySelector('summary + *').innerHTML = element.querySelector('summary + *').innerHTML;
            }
            else {
              filter.innerHTML = element.innerHTML;
            }
          }
        });
      }

      renderFiltersActive(responseText) {
        this._updateSection(responseText, 'FacetFiltersActive');
      }

  renderProductGridContainer(responseText) {
  const productGridContainer = document.getElementById('ProductGridContainer');
  if (productGridContainer === null) return;

  const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');

  // motion-list es el elemento que lleva la clase .card-grid
  const destination = productGridContainer.querySelector('motion-list');
  const source = parsedHTML.querySelector('motion-list');
  const paginationDestination = productGridContainer.querySelector('.pagination');
  const paginationSource = parsedHTML.querySelector('.pagination');

  if (source && destination) {
    // Reemplazar contenido completo (grid + list + promos) con lo que devuelve el servidor
    destination.innerHTML = source.innerHTML;

    // Reload motion-list
    destination.reload();

    // Aplicar vista actual (grid/list)
    applyCollectionViewToAll();

    // Re-inicializar interacciones de las product cards horizontales
    initHorizontalProductCards(destination);
  }

  if (paginationSource) {
    if (paginationDestination) {
      paginationDestination.innerHTML = paginationSource.innerHTML;
    } else {
      const wrapper = document.createElement('div');
      wrapper.innerHTML = paginationSource.outerHTML;
      productGridContainer.appendChild(wrapper.firstElementChild);
    }
  } else if (paginationDestination) {
    paginationDestination.remove();
  }
}

      renderProductCount(responseText) {
        this._updateSection(responseText, 'ProductCount');
      }

      renderSortBy(responseText) {
        this._updateSection(responseText, 'SortByContainer', (newContent, oldContainer) => {
          const oldFacetSort = oldContainer.querySelector('facet-sort');
          const newFacetSort = newContent.querySelector('facet-sort');
          if (!oldFacetSort || !newFacetSort) return;
          
          if (oldFacetSort.hasAttribute('style')) {
            newFacetSort.setAttribute('style', oldFacetSort.getAttribute('style'));
          }
        });
      }

      _updateSection(responseText, sectionId, modifier = null) {
        const container = document.getElementById(sectionId);
        if (!container) return false;

        const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
        const newContent = parsedHTML.getElementById(sectionId);
        if (!newContent) return false;

        // Apply custom modifications if provided
        modifier?.(newContent, container);

        container.innerHTML = newContent.innerHTML;
        return true;
      }
    }, { extends: 'form' }
  );
}

if (!customElements.get('facet-count')) {
  customElements.define(
    'facet-count',
    class FacetCount extends HTMLElement {
      constructor() {
        super();
      }

      facetUpdateUnsubscriber = undefined;

      connectedCallback() {
        this.facetUpdateUnsubscriber = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.facetUpdate, this.onFacetUpdate.bind(this));
      }

      disconnectedCallback() {
        if (this.facetUpdateUnsubscriber) {
          this.facetUpdateUnsubscriber();
        }
      }

      get itemCount() {
        return parseInt(this.innerText);
      }

      onFacetUpdate(event) {
        const parsedHTML = new DOMParser().parseFromString(event.responseText, 'text/html');
        const facetCount = parsedHTML.querySelector('facet-count');
        this.innerText = facetCount.innerHTML;
        this.hidden = this.itemCount === 0;
      }
    }
  );
}

if (!customElements.get('results-count')) {
  customElements.define(
    'results-count',
    class ResultsCount extends HTMLElement {
      constructor() {
        super();
      }

      facetUpdateUnsubscriber = undefined;

      connectedCallback() {
        this.facetUpdateUnsubscriber = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.facetUpdate, this.onFacetUpdate.bind(this));
      }

      disconnectedCallback() {
        if (this.facetUpdateUnsubscriber) {
          this.facetUpdateUnsubscriber();
        }
      }

      onFacetUpdate(event) {
        const parsedHTML = new DOMParser().parseFromString(event.responseText, 'text/html');
        const resultsCount = parsedHTML.querySelector('results-count');
        this.innerText = resultsCount.innerHTML;
      }
    }
  );
}

if (!customElements.get('facet-remove')) {
  customElements.define(
    'facet-remove',
    class FacetRemove extends MagnetLink {
      constructor() {
        super();

        this.addEventListener('click', this.onClick);
      }

      onClick(event) {
        const form = this.closest('form[is="facet-form"]') || document.querySelector('form[is="facet-form"]');

        if (form) {
          event.preventDefault();

          const url = new URL(this.href);
          url.searchParams.set('section_id', theme.utils.sectionId(form));
          form.renderSection(url.toString(), event);
        }
      }
    }, { extends: 'a' }
  );
}

if (!customElements.get('facet-sort')) {
  customElements.define(
    'facet-sort',
    class FacetSort extends HTMLElement {
      constructor() {
        super();

        Motion.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });

        this.addEventListener('change', this.onChange);
        this.button.addEventListener('click', this.show.bind(this));
        this.close.addEventListener('click', this.hide.bind(this));
        document.addEventListener('click', this.onWindowClick.bind(this));
      }

      get listbox() {
        return this.querySelector('.sort-listbox');
      }

      get selection() {
        return this.querySelector('.sort-selection');
      }

      get button() {
        return this.querySelector('.sort-by');
      }

      get close() {
        return this.querySelector('.sort-close');
      }

      init() {
        this.initButton();
        this.style.setProperty('--facet-listbox-height', `${this.listbox.getBoundingClientRect().height.toFixed(1)}px`);
      }

      initButton() {
        const value = this.selection.innerText;
        const width = theme.getElementWidth(this.selection, value);
        this.style.setProperty('--facet-button-width', `${width}px`);
      }

      onChange(event) {
        const form = this.closest('form[is="facet-form"]') || document.querySelector('form[is="facet-form"]');

        if (form) {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', event.target.value);
          url.searchParams.set('section_id', theme.utils.sectionId(form));
          url.searchParams.delete('page');
          form.renderSection(url.toString(), event);
        }

        this.selection.innerText = event.target.nextElementSibling.innerText;
        this.initButton();
        this.hide();
      }

      show() {
        this.button.setAttribute('open', '');
      }

      hide(immediate = true) {
        if (this.button.hasAttribute('open')) {
          setTimeout(() => {
            this.button.removeAttribute('open');
          }, 100);

          if (theme.config.isTouch || document.body.getAttribute('data-button-hover') === 'none') return;
          
          const btnFill = this.button.querySelector('[data-fill');
          Motion.animate(btnFill, { y: ['0%', immediate ? '0%' : '-76%'] }, { duration: 0.6, delay: immediate ? 0 : 0.2 });
        }
      }

      onWindowClick(event) {
        if (!this.contains(event.target)) {
          if (this.button.hasAttribute('open')) {
            this.hide(false);
          }
        }
      }
    }
  );
}

if (!customElements.get('facet-sticky')) {
  customElements.define(
    'facet-sticky',
    class FacetSticky extends HTMLElement {
      constructor() {
        super();

        new IntersectionObserver(this.handleIntersection.bind(this), { rootMargin: `-${screen.availHeight - 200}px 0px ${screen.availHeight}px 0px` }).observe(document.querySelector('.collection-section'));
      }

      get button() {
        return this.querySelector('.button');
      }

      handleIntersection(entries) {
        if (entries[0].isIntersecting) {
          Motion.animate(this.button, { opacity: 1, visibility: 'visible', transform: ['translateY(15px)', 'translateY(0)'] }, { duration: 1, easing: [0.16, 1, 0.3, 1] });
        }
        else {
          Motion.animate(this.button, { opacity: 0, visibility: 'hidden', transform: ['translateY(0)', 'translateY(15px)'] }, { duration: 1, easing: [0.16, 1, 0.3, 1] });
        }
      }
    }
  );
}

if (!customElements.get('price-range')) {
  customElements.define(
    'price-range',
    class PriceRange extends HTMLElement {
      constructor() {
        super();

        this.rangeMin = this.querySelector('input[type="range"]:first-child');
        this.rangeMax = this.querySelector('input[type="range"]:last-child');
        this.inputMin = this.querySelector('input[name="filter.v.price.gte"]');
        this.inputMax = this.querySelector('input[name="filter.v.price.lte"]');

        this.inputMin.addEventListener('focus', this.inputMin.select);
        this.inputMax.addEventListener('focus', this.inputMax.select);
        this.inputMin.addEventListener('change', this.onInputMinChange.bind(this));
        this.inputMax.addEventListener('change', this.onInputMaxChange.bind(this));

        this.rangeMin.addEventListener('change', this.onRangeMinChange.bind(this));
        this.rangeMax.addEventListener('change', this.onRangeMaxChange.bind(this));
        this.rangeMin.addEventListener('input', this.onRangeMinInput.bind(this));
        this.rangeMax.addEventListener('input', this.onRangeMaxInput.bind(this));
      }

      onInputMinChange(event) {
        event.preventDefault();
        event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(this.inputMax.value || event.target.max) - 1), event.target.min);
        this.rangeMin.value = event.target.value;
        this.rangeMin.parentElement.style.setProperty('--range-min', `${parseInt(this.rangeMin.value) / parseInt(this.rangeMin.max) * 100}%`);
      }

      onInputMaxChange(event) {
        event.preventDefault();
        event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(this.inputMin.value || event.target.min) + 1), event.target.max);
        this.rangeMax.value = event.target.value;
        this.rangeMax.parentElement.style.setProperty('--range-max', `${parseInt(this.rangeMax.value) / parseInt(this.rangeMax.max) * 100}%`);
      }

      onRangeMinChange(event) {
        event.stopPropagation();
        this.inputMin.value = event.target.value;
        this.inputMin.dispatchEvent(new Event('change', { bubbles: true }));
      }

      onRangeMaxChange(event) {
        event.stopPropagation();
        this.inputMax.value = event.target.value;
        this.inputMax.dispatchEvent(new Event('change', { bubbles: true }));
      }

      onRangeMinInput(event) {
        event.target.value = Math.min(parseInt(event.target.value), parseInt(this.inputMax.value || event.target.max) - 1);
        event.target.parentElement.style.setProperty('--range-min', `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
        this.inputMin.value = event.target.value;
      }

      onRangeMaxInput(event) {
        event.target.value = Math.max(parseInt(event.target.value), parseInt(this.inputMin.value || event.target.min) + 1);
        event.target.parentElement.style.setProperty('--range-max', `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
        this.inputMax.value = event.target.value;
      }
    }
  );
}

if (!customElements.get('infinite-button')) {
  customElements.define(
    'infinite-button',
    class InfiniteButton extends HoverButton {
      constructor() {
        super();

        this.onClickHandler = this.onClick.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.onClickHandler);

        if (this.getAttribute('mode') == 'infinite') {
          Motion.inView(this, this.onClickHandler, { margin: '200px 0px 200px 0px' });
        }
        
        // Setup global view applier
        this.setupGlobalViewHandler();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClickHandler);
        document.removeEventListener('collection:viewApplied', this.globalViewHandler);
      }
      
      setupGlobalViewHandler() {
        // Listener global para aplicar vista cuando se añadan nuevas cards
        this.globalViewHandler = () => {
          applyCollectionViewToAll();
        };
        document.addEventListener('collection:viewApplied', this.globalViewHandler);
      }


      onClick() {
        if (this.hasAttribute('aria-busy')) return;

        this.abortController?.abort();
        this.abortController = new AbortController();

        this.enableLoading();
        const url = this.buildUrl().toString();

        fetch(url, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.renderPagination(responseText);
            this.renderProductGridContainer(responseText);
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            }
            else {
              console.error(error);
            }
          });
      }

      renderPagination(responseText) {
        const productGridContainer = document.getElementById('ProductGridContainer');
        if (productGridContainer === null) return;

        const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = productGridContainer.querySelector('.pagination');
        const source = parsedHTML.querySelector('.pagination');

        if (source) {
          destination.innerHTML = source.innerHTML;
        }
        else {
          destination.remove();
        }
      }

  renderProductGridContainer(responseText) {
  const productGridContainer = document.getElementById('ProductGridContainer');
  if (productGridContainer === null) return;
  productGridContainer.style.removeProperty('opacity');
  productGridContainer.style.removeProperty('visibility');
  productGridContainer.style.removeProperty('transform');
  productGridContainer.style.removeProperty('--motion-translateY');

  const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');

  // motion-list es el elemento que lleva la clase .card-grid
  const destination = productGridContainer.querySelector('motion-list');
  const source = parsedHTML.querySelector('motion-list');

  if (source && destination) {
    // ✅ Añadir TODOS los hijos (grid + list + promos) tal cual vienen del servidor
    Array.from(source.children).forEach((child) => {
      destination.appendChild(child);
    });

    // Reload motion-list
    destination.reload();

    applyCollectionViewToAll();
    initHorizontalProductCards(destination);

    // Aplicar vista con triple check
    setTimeout(() => {
      applyCollectionViewToAll();

      setTimeout(() => {
        applyCollectionViewToAll();
        initHorizontalProductCards(destination);
      }, 100);
    }, 50);
  }
}

      
      buildUrl() {
        const url = new URL(this.getAttribute('action'));
        url.searchParams.set('section_id', theme.utils.sectionId(this));
        return url;
      }

      enableLoading() {
        this.classList.add('pointer-events-none');
        this.setAttribute('aria-busy', 'true');
      }
    }, { extends: 'button' }
  );
}

if (!customElements.get('facets-topbar')) {
  customElements.define(
    'facets-topbar',
    class FacetsTopbar extends StickyElement {
      constructor() {
        super();
      }

      positionStickySidebar() {
        const bounding = this.getBoundingClientRect();
        if (bounding.top === 0) {
          document.body.classList.add('facets-topbar--active');
        }
        else {
          document.body.classList.remove('facets-topbar--active');
        }
      }
    }
  );
}

if (!customElements.get('model-view')) {
  customElements.define(
    'model-view',
    class ModelView extends MagnetButton {
      constructor() {
        super();

        Motion.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });

        this._open = this.hasAttribute('open');
        this.onClickHandler = this.onClick.bind(this);
      }

      set open(value) {
        if (value !== this._open) {
          this._open = value;
          value ? this.setAttribute('open', '') : this.removeAttribute('open');
        }
      }

      static get observedAttributes() {
        return ['open'];
      }

      get open() {
        return this._open;
      }

      connectedCallback() {
        this.addEventListener('click', this.onClickHandler);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClickHandler);
      }

      attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'open') {
          this.setActiveModel(newValue === '');
        }
      }

      init() {
        if (theme.config.hasLocalStorage) {
          const isActive = window.localStorage.getItem(`${theme.settings.themeName}:model-view`) || 'false';
          this.open = isActive === 'true';
        }
      }

      onClick(event) {
        event.preventDefault();
        this.open = !this.open;
      }

      setActiveModel(isActive) {
        const container = document.getElementById('ProductGridContainer');
        container.classList.toggle('lifestyle', isActive);

        container.querySelectorAll('video-media').forEach((videoMedia) => videoMedia.pause());

        if (theme.config.hasLocalStorage) {
          window.localStorage.setItem(`${theme.settings.themeName}:model-view`, isActive);
        }
      }
    }, { extends: 'button' }
  );
}

if (!customElements.get('sub-collections')) {
  customElements.define(
    'sub-collections',
    class SubCollections extends HTMLSelectElement {
      constructor() {
        super();
        this.addEventListener('change', this.onChange);
      }
    
      onChange() {
        window.location.href = this.value;
      }
    }, { extends: 'select' }
  );
}

function initHorizontalProductCards(scope = document) {
  const cards = scope.querySelectorAll('.horizontal-product-new');

  if (!initHorizontalProductCards.cartState) {
    initHorizontalProductCards.cartState = { cache: null, inFlight: null };
  }
  const cartState = initHorizontalProductCards.cartState;

  const normalizeValue = (value = '') => String(value).toLowerCase().trim();
  const normalizeLoose = (value = '') =>
    normalizeValue(value)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/,/g, '.')
      .replace(/[^a-z0-9.]+/g, '');

  const extractNumbers = (value = '') => {
    const normalized = normalizeValue(value).replace(/,/g, '.');
    const matches = normalized.match(/\d+(?:\.\d+)?/g);
    if (!matches) return [];
    return matches.map((item) => Number.parseFloat(item)).filter((num) => !Number.isNaN(num));
  };
  const matchesFilterValue = (target = '', rawValue = '') => {
    const targetLoose = normalizeLoose(target);
    const valueLoose = normalizeLoose(rawValue);
    if (!targetLoose || !valueLoose) return false;

    const valueNumbers = extractNumbers(rawValue);
    const targetNumbers = extractNumbers(target);

    if (valueNumbers.length) {
      const hasDash = /-|–|—/.test(rawValue);
      const hasMultiply = /x|×/i.test(rawValue);
      const matchesAny = valueNumbers.some((valueNumber) =>
        targetNumbers.some((num) => Math.abs(num - valueNumber) < 0.001)
      );
      const matchesAll = valueNumbers.every((valueNumber) =>
        targetNumbers.some((num) => Math.abs(num - valueNumber) < 0.001)
      );

      if (hasDash && !hasMultiply) {
        return matchesAny;
      }
      return matchesAll;
    }

    return targetLoose.includes(valueLoose) || valueLoose.includes(targetLoose);
  };

  const getActiveVariantOptionFilters = () => {
    const getFilterLabelValue = (name, value) => {
      if (!name || !value) return value;
      const escapedName = escapeSelector(name);
      const escapedValue = escapeSelector(value);
      const input = document.querySelector(`.facet-form input[name="${escapedName}"][value="${escapedValue}"]`);
      if (!input) return value;

      const label =
        document.querySelector(`label[for="${escapeSelector(input.id)}"]`) ||
        input.closest('label');
      if (!label) return value;

      const text = label.textContent.replace(/\(\d+\)\s*$/, '').trim();
      return text || value;
    };

    const entries = [];
    const params = new URLSearchParams(window.location.search);
    params.forEach((value, key) => {
      if (key.startsWith('filter.p.m.') || key.startsWith('filter.v.m.')) {
        entries.push([key, getFilterLabelValue(key, value)]);
        return;
      }
      entries.push([key, value]);
    });

    document.querySelectorAll('.facet-form input[name^="filter."]:checked').forEach((input) => {
      if (input.name.startsWith('filter.p.m.') || input.name.startsWith('filter.v.m.')) {
        entries.push([input.name, getFilterLabelValue(input.name, input.value)]);
        return;
      }
      entries.push([input.name, input.value]);
    });

    const filters = [];
    const price = { min: null, max: null };
    const optionPrefix = 'filter.v.option.';
    const variantMetafieldPrefix = 'filter.v.m.';
    const productMetafieldPrefix = 'filter.p.m.';

    entries.forEach(([key, value]) => {
      if (key === 'filter.v.price.gte') {
        price.min = value;
        return;
      }
      if (key === 'filter.v.price.lte') {
        price.max = value;
        return;
      }
      if (key === 'filter.p.vendor') {
        const normalized = normalizeValue(value);
        let filter = filters.find((item) => item.type === 'vendor');
        if (!filter) {
          filter = { type: 'vendor', values: new Set() };
          filters.push(filter);
        }
        filter.values.add(normalized);
        return;
      }
      if (key.startsWith(optionPrefix)) {
        const optionHandle = key.slice(optionPrefix.length);
        if (!optionHandle) return;
        const normalized = normalizeValue(value);
        let filter = filters.find((item) => item.type === 'option' && item.key === optionHandle);
        if (!filter) {
          filter = { type: 'option', key: optionHandle, values: new Set() };
          filters.push(filter);
        }
        filter.values.add(normalized);
        return;
      }

      if (key.startsWith(variantMetafieldPrefix)) {
        const metaHandle = key.slice(variantMetafieldPrefix.length);
        if (!metaHandle) return;
        const normalized = normalizeValue(value);
        let filter = filters.find((item) => item.type === 'variant_metafield' && item.key === metaHandle);
        if (!filter) {
          filter = { type: 'variant_metafield', key: metaHandle, values: new Set() };
          filters.push(filter);
        }
        filter.values.add(normalized);
        return;
      }

      if (key.startsWith(productMetafieldPrefix)) {
        const metaHandle = key.slice(productMetafieldPrefix.length);
        if (!metaHandle) return;
        const normalized = normalizeValue(value);
        let filter = filters.find((item) => item.type === 'product_metafield' && item.key === metaHandle);
        if (!filter) {
          filter = { type: 'product_metafield', key: metaHandle, values: new Set() };
          filters.push(filter);
        }
        filter.values.add(normalized);
      }
    });

    return { filters, price };
  };

  const escapeSelector = (value) => {
    if (window.CSS && typeof CSS.escape === 'function') {
      return CSS.escape(value);
    }
    return String(value).replace(/"/g, '\\"');
  };

  const applyVariantFilters = (card) => {
    const { filters: optionFilters, price } = getActiveVariantOptionFilters();
    const filterKeys = optionFilters.map((filter) => filter.key);
    const rows = card.querySelectorAll('.variant-item');
    const variantScopedProductMetafields = new Set(['custom.diametro', 'custom.diametro_rueda', 'custom.diametro_cubierta']);
    const scopedProductFilterState = new Map();

    const hasPriceFilter = price.min !== null || price.max !== null;
    if (!filterKeys.length && !hasPriceFilter) {
      rows.forEach((row) => {
        row.removeAttribute('hidden');
        row.style.removeProperty('display');
      });
      card.querySelectorAll('.variant-group[data-variant-group]').forEach((group) => {
        group.removeAttribute('hidden');
        group.style.removeProperty('display');
      });
      card.removeAttribute('hidden');
      card.style.removeProperty('display');
      return;
    }

    const vendorFilter = optionFilters.find((filter) => filter.type === 'vendor');
    if (vendorFilter) {
      const vendor = normalizeValue(card.getAttribute('data-vendor') || '');
      const matchesVendor = Array.from(vendorFilter.values).some((value) => vendor === value);
      if (!matchesVendor) {
        card.setAttribute('hidden', 'hidden');
        card.style.display = 'none';
        return;
      }
    }

    const minValue = price.min !== null ? Number.parseFloat(String(price.min).replace(',', '.')) : null;
    const maxValue = price.max !== null ? Number.parseFloat(String(price.max).replace(',', '.')) : null;
    const priceMinCents = Number.isFinite(minValue) ? (minValue >= 1000 ? minValue : minValue * 100) : null;
    const priceMaxCents = Number.isFinite(maxValue) ? (maxValue >= 1000 ? maxValue : maxValue * 100) : null;

    optionFilters.forEach((filter) => {
      if (filter.type !== 'product_metafield' || !variantScopedProductMetafields.has(filter.key)) return;

      const lastSegment = filter.key.split('.').pop();
      const metaAttrDashed = `data-metafield-custom-${lastSegment.replace(/_/g, '-')}`;
      const metaAttrRaw = `data-metafield-custom-${lastSegment}`;
      const matchingRows = new Set();

      rows.forEach((row) => {
        const scopedRowValue = [
          row.getAttribute('data-variant-group') || '',
          row.getAttribute('data-variant-title') || '',
          row.getAttribute('data-variant-sku') || '',
          row.getAttribute('data-filter-text') || ''
        ]
          .filter(Boolean)
          .join(' ');

        const rowMatches = Array.from(filter.values).some((value) => matchesFilterValue(scopedRowValue, value));
        if (rowMatches) matchingRows.add(row);
      });

      const firstRow = rows[0];
      const productValue = firstRow
        ? firstRow.getAttribute(metaAttrDashed) || firstRow.getAttribute(metaAttrRaw) || ''
        : '';
      const productMatches = productValue
        ? Array.from(filter.values).some((value) => matchesFilterValue(productValue, value))
        : false;

      scopedProductFilterState.set(filter.key, { matchingRows, productMatches });
    });

    rows.forEach((row) => {
      let matches = true;
      const rowTitle = normalizeLoose(row.getAttribute('data-variant-title') || '');
      const rowSku = normalizeLoose(row.getAttribute('data-variant-sku') || '');

      if (hasPriceFilter) {
        const rowPrice = Number.parseInt(row.getAttribute('data-variant-price'), 10);
        if (!Number.isNaN(rowPrice)) {
          if (priceMinCents !== null && rowPrice < priceMinCents) matches = false;
          if (priceMaxCents !== null && rowPrice > priceMaxCents) matches = false;
        }
      }

      for (const filter of optionFilters) {
        if (filter.type === 'vendor') continue;
        const filterKey = filter.key;
        const lastSegment = filterKey.split('.').pop();
        const optionAttr = `data-option-${lastSegment}`;
        const metaAttrDashed = `data-metafield-custom-${lastSegment.replace(/_/g, '-')}`;
        const metaAttrRaw = `data-metafield-custom-${lastSegment}`;
        const variantMetaAttrDashed = `data-variant-metafield-custom-${lastSegment.replace(/_/g, '-')}`;
        const variantMetaAttrRaw = `data-variant-metafield-custom-${lastSegment}`;

        if (filter.type === 'product_metafield' && variantScopedProductMetafields.has(filterKey)) {
          const scopedState = scopedProductFilterState.get(filterKey);
          const hasScopedMatches = scopedState && scopedState.matchingRows.size > 0;
          const match = hasScopedMatches ? scopedState.matchingRows.has(row) : Boolean(scopedState?.productMatches);

          if (!match) {
            matches = false;
            break;
          }

          continue;
        }

        let rowValue = null;
        if (filter.type === 'option') {
          rowValue = row.getAttribute(optionAttr);
        } else if (filter.type === 'variant_metafield') {
          rowValue =
            row.getAttribute(variantMetaAttrDashed) ||
            row.getAttribute(variantMetaAttrRaw) ||
            row.getAttribute(metaAttrDashed) ||
            row.getAttribute(metaAttrRaw);
        } else if (filter.type === 'product_metafield') {
          rowValue =
            row.getAttribute(metaAttrDashed) ||
            row.getAttribute(metaAttrRaw) ||
            row.getAttribute(variantMetaAttrDashed) ||
            row.getAttribute(variantMetaAttrRaw);
        } else {
          rowValue =
            row.getAttribute(optionAttr) ||
            row.getAttribute(variantMetaAttrDashed) ||
            row.getAttribute(variantMetaAttrRaw) ||
            row.getAttribute(metaAttrDashed) ||
            row.getAttribute(metaAttrRaw);
        }
        if (rowValue) {
          const match = Array.from(filter.values).some((value) => matchesFilterValue(rowValue, value));
          if (!match) {
            matches = false;
            break;
          }
        } else {
          const rowText = row.getAttribute('data-filter-text') || '';
          const match = Array.from(filter.values).some((value) => {
            return (
              matchesFilterValue(rowTitle, value) ||
              matchesFilterValue(rowSku, value) ||
              matchesFilterValue(rowText, value)
            );
          });
          if (!match) {
            matches = false;
            break;
          }
        }
      }
      if (matches) {
        row.removeAttribute('hidden');
        row.style.removeProperty('display');
      } else {
        row.setAttribute('hidden', 'hidden');
        row.style.display = 'none';
      }
    });

    card.querySelectorAll('.variant-group[data-variant-group]').forEach((group) => {
      const groupKey = group.dataset.variantGroup;
      if (!groupKey) return;
      const selector = `.variant-item[data-variant-group="${escapeSelector(groupKey)}"]:not([hidden])`;
      const hasVisible = card.querySelector(selector);
      if (hasVisible) {
        group.removeAttribute('hidden');
        group.style.removeProperty('display');
      } else {
        group.setAttribute('hidden', 'hidden');
        group.style.display = 'none';
      }
    });

    const hasVisibleRows = card.querySelector('.variant-item:not([hidden])');
    if (hasVisibleRows) {
      card.removeAttribute('hidden');
      card.style.removeProperty('display');
    } else {
      card.setAttribute('hidden', 'hidden');
      card.style.display = 'none';
    }
  };

  let totalsUpdateTimer = null;
  const scheduleTotalsUpdate = () => {
    if (totalsUpdateTimer) return;
    totalsUpdateTimer = setTimeout(() => {
      totalsUpdateTimer = null;
      if (initHorizontalProductCards.updateAllTotals) {
        initHorizontalProductCards.updateAllTotals();
      }
    }, 120);
  };

  const observePriceChanges = (card) => {
    if (!card || card.dataset.priceObserverBound) return;
    card.dataset.priceObserverBound = 'true';

    const targets = card.querySelectorAll(
      '.variant-price, [data-b2b-dual-price], [bss-b2b-product-price]'
    );
    if (!targets.length) return;

    const observer = new MutationObserver(() => {
      scheduleTotalsUpdate();
    });

    targets.forEach((target) => {
      observer.observe(target, {
        childList: true,
        characterData: true,
        attributes: true,
        subtree: true
      });
    });
  };

  const updateButtonState = (input) => {
    if (!input || input.disabled) return;

    const container = input.closest('.quantity');
    if (!container) return;

    const decreaseBtn = container.querySelector('[data-action="decrease"]');
    const increaseBtn = container.querySelector('[data-action="increase"]');
    const addBtn = container.querySelector('.variant-add-btn');
    const currentValue = parseInt(input.value, 10) || 0;
    const min = parseInt(input.min, 10) || 0;
    const max = parseInt(input.max, 10) || 999;

    if (decreaseBtn) decreaseBtn.disabled = currentValue <= min;
    if (increaseBtn) increaseBtn.disabled = currentValue >= max;
    if (addBtn) addBtn.disabled = currentValue <= 0 || input.disabled;
  };

  const parseMoneyToCents = (text) => {
    const cleaned = (text || '').replace(/[^\d.,-]/g, '');
    if (!cleaned) return NaN;
    const lastComma = cleaned.lastIndexOf(',');
    const lastDot = cleaned.lastIndexOf('.');
    let normalized = cleaned;

    if (lastComma > lastDot) {
      normalized = cleaned.replace(/\./g, '').replace(',', '.');
    } else {
      normalized = cleaned.replace(/,/g, '');
    }

    const value = Number.parseFloat(normalized);
    if (Number.isNaN(value)) return NaN;
    return Math.round(value * 100);
  };

  const parseMoneyFromText = (text) => {
    const matches = (text || '').match(/-?\d[\d\s.,]*/g);
    if (!matches) return NaN;
    let cents = NaN;
    matches.forEach((candidate) => {
      const parsed = parseMoneyToCents(candidate);
      if (!Number.isNaN(parsed)) cents = parsed;
    });
    return cents;
  };

  const getRowUnitPrice = (row) => {
    if (!row) return NaN;
    const priceRoot = row.querySelector('.variant-price') || row;
    const preferredEl =
      priceRoot.querySelector('[data-role="after"]') ||
      priceRoot.querySelector('.price__regular:not([hidden])') ||
      priceRoot.querySelector('.price__sale:not([hidden])') ||
      priceRoot.querySelector('.price__regular') ||
      priceRoot.querySelector('.price');

    let price = parseMoneyFromText(preferredEl?.textContent);
    if (Number.isNaN(price)) {
      price = parseMoneyFromText(priceRoot?.textContent);
    }
    if (Number.isNaN(price)) {
      price = parseInt(row.getAttribute('data-variant-price'), 10);
    }

    return price;
  };


  const updateTotalsFromCart = (card, cart) => {
    const totalQtyEl = card.querySelector('[data-quantity-total]');
    const totalPriceEl = card.querySelector('[data-price-total]');
    if (!totalQtyEl && !totalPriceEl) return;

    if (!cart || !Array.isArray(cart.items)) {
      if (totalQtyEl) totalQtyEl.textContent = '0';
      if (totalPriceEl && theme?.Currency?.formatMoney && theme?.settings) {
        const format = theme.settings.currencyCodeEnabled ? theme.settings.moneyWithCurrencyFormat : theme.settings.moneyFormat;
        totalPriceEl.textContent = theme.Currency.formatMoney(0, format);
      } else if (totalPriceEl) {
        totalPriceEl.textContent = '0';
      }
      return;
    }

    let totalQty = 0;
    let totalCents = 0;

    const productId = parseInt(card.dataset.productId, 10);
    const rowByVariantId = new Map();
    card.querySelectorAll('.variant-item').forEach((row) => {
      const variantId = parseInt(row.getAttribute('data-variant-id'), 10);
      if (!Number.isNaN(variantId)) rowByVariantId.set(variantId, row);
    });

    cart.items.forEach((item) => {
      if (productId && item.product_id === productId) {
        totalQty += item.quantity || 0;
        let linePrice = typeof item.final_line_price === 'number' ? item.final_line_price : item.line_price;
        const row = rowByVariantId.get(item.variant_id);
        const unitPrice = getRowUnitPrice(row);
        if (!Number.isNaN(unitPrice)) {
          linePrice = unitPrice * (item.quantity || 0);
        }
        if (typeof linePrice === 'number') totalCents += linePrice;
      } else if (rowByVariantId.has(item.variant_id)) {
        totalQty += item.quantity || 0;
        let linePrice = typeof item.final_line_price === 'number' ? item.final_line_price : item.line_price;
        const row = rowByVariantId.get(item.variant_id);
        const unitPrice = getRowUnitPrice(row);
        if (!Number.isNaN(unitPrice)) {
          linePrice = unitPrice * (item.quantity || 0);
        }
        if (typeof linePrice === 'number') totalCents += linePrice;
      }
    });

    if (totalQtyEl) totalQtyEl.textContent = totalQty;
    if (totalPriceEl && theme?.Currency?.formatMoney && theme?.settings) {
      const format = theme.settings.currencyCodeEnabled ? theme.settings.moneyWithCurrencyFormat : theme.settings.moneyFormat;
      totalPriceEl.textContent = theme.Currency.formatMoney(totalCents, format);
    }
  };

  const fetchCart = async () => {
    if (cartState.inFlight) return cartState.inFlight;

    cartState.inFlight = (async () => {
      try {
        const response = await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET') });
        const cartJson = await response.json();
        cartState.cache = cartJson;
        return cartJson;
      } catch (error) {
        console.error('Cart fetch error:', error);
        return null;
      } finally {
        cartState.inFlight = null;
      }
    })();

    return cartState.inFlight;
  };

  const updateAllTotals = async (cart = null) => {
    const useCart = cart || cartState.cache || (await fetchCart());
    if (!useCart) return;

    document.querySelectorAll('.horizontal-product-new').forEach((card) => {
      updateTotalsFromCart(card, useCart);
    });
  };

  initHorizontalProductCards.updateAllTotals = updateAllTotals;
  const refreshCartDrawer = async ({ open = true } = {}) => {
    const cartJson = await fetchCart();

    if (cartJson && theme?.pubsub?.publish && theme?.pubsub?.PUB_SUB_EVENTS?.cartUpdate) {
      theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
        source: 'collection-list',
        cart: cartJson
      });
    }

    document.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { open }
    }));

    return cartJson;
  };

  const addLineItem = async (variantId, quantity) => {
    const body = JSON.stringify({ items: [{ id: variantId, quantity }] });
    const response = await fetch(theme.routes.cart_add_url, { ...theme.utils.fetchConfig('json'), body });
    if (!response.ok) {
      throw new Error('Cart add failed');
    }
    return response.json();
  };

  const resetQuantityInputAfterAdd = (input) => {
    if (!input) return;

    const isMainVariantColumnInput = Boolean(input.closest('.variant-qty__controls'));
    if (isMainVariantColumnInput) {
      input.value = 1;
    } else {
      const min = parseInt(input.min, 10);
      input.value = Number.isNaN(min) ? 1 : min;
    }
  };

  cards.forEach((card) => {
    const quantityInputs = card.querySelectorAll('.variant-quantity');
    const quantityButtons = card.querySelectorAll('.quantity__button');
    const addAllBtn = card.querySelector('.add-all-to-cart-btn');
    const addButtons = card.querySelectorAll('.variant-add-btn');

    quantityInputs.forEach((input) => updateButtonState(input));
    applyVariantFilters(card);
    observePriceChanges(card);

    quantityButtons.forEach((btn) => {
      if (btn.dataset.bound) return;
      btn.dataset.bound = true;

      btn.addEventListener('click', (event) => {
        event.preventDefault();
        if (btn.disabled) return;

        const variantId = btn.dataset.variantId;
        const input = card.querySelector(`input[data-variant-id="${variantId}"]`);
        if (!input || input.disabled) return;

        const action = btn.dataset.action;
        const currentValue = parseInt(input.value, 10) || 0;
        const min = parseInt(input.min, 10) || 0;
        const max = parseInt(input.max, 10) || 999;
        let nextValue = currentValue;

        if (action === 'increase' && currentValue < max) {
          nextValue = currentValue + 1;
        } else if (action === 'decrease' && currentValue > min) {
          nextValue = currentValue - 1;
        }

        if (nextValue !== currentValue) {
          input.value = nextValue;
          updateButtonState(input);
        }
      });
    });

    quantityInputs.forEach((input) => {
      if (input.dataset.bound) return;
      input.dataset.bound = true;

      input.addEventListener('change', () => {
        if (input.disabled) return;

        const min = parseInt(input.min, 10) || 0;
        const max = parseInt(input.max, 10) || 999;
        let value = parseInt(input.value, 10) || 0;

        if (value < min) value = min;
        if (value > max) value = max;

        input.value = value;
        updateButtonState(input);
      });
    });

    addButtons.forEach((btn) => {
      if (btn.dataset.bound) return;
      btn.dataset.bound = true;

      btn.addEventListener('click', async (event) => {
        event.preventDefault();
        if (btn.disabled) return;

        const variantId = btn.dataset.variantId;
        const input = card.querySelector(`input[data-variant-id="${variantId}"]`);
        if (!input || input.disabled) return;

        const quantity = parseInt(input.value, 10) || 0;
        if (quantity <= 0) return;

        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');

        try {
          await addLineItem(variantId, quantity);
          resetQuantityInputAfterAdd(input);
          updateButtonState(input);
          const cartJson = await refreshCartDrawer({ open: true });
          await updateAllTotals(cartJson);
        } catch (error) {
          console.error('Cart add error:', error);
        } finally {
          btn.removeAttribute('aria-busy');
          updateButtonState(input);
        }
      });
    });

    if (addAllBtn) {
      if (addAllBtn.dataset.bound) return;
      addAllBtn.dataset.bound = true;

      addAllBtn.addEventListener('click', async (event) => {
        event.preventDefault();

        const items = [];

        quantityInputs.forEach((input) => {
          if (input.disabled) return;
          const quantity = parseInt(input.value, 10) || 0;
          if (quantity > 0) {
            items.push({
              id: input.dataset.variantId,
              quantity
            });
          }
        });

        if (!items.length) return;

        addAllBtn.disabled = true;
        addAllBtn.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch(theme.routes.cart_add_url, {
            ...theme.utils.fetchConfig('json'),
            body: JSON.stringify({ items })
          });

          if (response.ok) {
            quantityInputs.forEach((input) => {
              if (!input.disabled) {
                resetQuantityInputAfterAdd(input);
                updateButtonState(input);
              }
            });
            const cartJson = await refreshCartDrawer({ open: true });
            await updateAllTotals(cartJson);
          }
        } catch (error) {
          console.error('Cart add error:', error);
        } finally {
          addAllBtn.removeAttribute('aria-busy');
          addAllBtn.disabled = false;
        }
      });
    }
  });

  updateAllTotals();

  if (!initHorizontalProductCards.cartListenersBound && theme?.pubsub?.subscribe && theme?.pubsub?.PUB_SUB_EVENTS?.cartUpdate) {
    initHorizontalProductCards.cartListenersBound = true;
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, (event) => {
      const cart = event?.cart || event?.detail?.cart;
      if (cart) cartState.cache = cart;
      if (initHorizontalProductCards.updateAllTotals) {
        initHorizontalProductCards.updateAllTotals(cart);
      }
    });

    document.addEventListener('cart:refresh', () => {
      if (initHorizontalProductCards.updateAllTotals) {
        initHorizontalProductCards.updateAllTotals();
      }
    });

    document.addEventListener('bss-b2b:price-refresh', () => {
      if (initHorizontalProductCards.updateAllTotals) {
        initHorizontalProductCards.updateAllTotals();
      }
    });
  }
}

function initComplementaryColumns(scope = document) {
  const columns = scope.querySelectorAll('product-recommendations.horizontal-product__complementary-column[data-url], product-recommendations.horizontal-product__complementary-column[data-source="metafield"]');
  if (!columns.length) return;

  customElements.whenDefined('product-recommendations').then(() => {
    columns.forEach((column) => {
      if (column.dataset.complementaryBound) return;
      column.dataset.complementaryBound = 'true';
      if (typeof column.init === 'function') {
        column.init();
      }
    });
  });
}

document.addEventListener('collection:reloaded', () => {
  const container = document.getElementById('ProductGridContainer');
  if (container) {
    initHorizontalProductCards(container);
    initComplementaryColumns(container);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  initHorizontalProductCards();
  initComplementaryColumns();
});
